export default __webpack_public_path__ + "static/media/Next-Appts-mWeb.ba626921.png";